var map = {
	"./icon-bible.svg": "d1a7",
	"./icon-car-service.svg": "a87c",
	"./icon-car.svg": "c8d4",
	"./icon-category-tag.svg": "807a",
	"./icon-category.svg": "e671",
	"./icon-cityroad.svg": "c201",
	"./icon-connected-car.svg": "b61b",
	"./icon-danger.svg": "090c",
	"./icon-default.svg": "b906",
	"./icon-education.svg": "00e0",
	"./icon-family.svg": "ad3d",
	"./icon-free-ride.svg": "78b3",
	"./icon-fuel-tank.svg": "5ab9",
	"./icon-gym.svg": "135a",
	"./icon-health-heart-rate.svg": "7b35",
	"./icon-health-pill.svg": "bcc2",
	"./icon-highway.svg": "4fc4",
	"./icon-home.svg": "67cb",
	"./icon-l17.svg": "a7b6",
	"./icon-list.svg": "9b6e",
	"./icon-marker.svg": "c452",
	"./icon-moon.svg": "9beb",
	"./icon-motorway.svg": "d9b6",
	"./icon-noon.svg": "4db9",
	"./icon-notification.svg": "d849",
	"./icon-party.svg": "c0cf",
	"./icon-people.svg": "22d3",
	"./icon-person.svg": "d9ac",
	"./icon-play.svg": "1ea4",
	"./icon-plus.svg": "b4d1",
	"./icon-restaurant.svg": "8343",
	"./icon-road.svg": "1561",
	"./icon-rule.svg": "bfa4",
	"./icon-shopping-basket.svg": "be17",
	"./icon-shopping.svg": "7e1f",
	"./icon-sleep.svg": "6e67",
	"./icon-sportwatch.svg": "089d",
	"./icon-sunrise.svg": "7d90",
	"./icon-sunset.svg": "bac7",
	"./icon-trafficlight.svg": "f65b",
	"./icon-transportation-bus.svg": "3d4f",
	"./icon-transportation-railway.svg": "13ec",
	"./icon-transportation-taxi.svg": "9313",
	"./icon-transportation-water.svg": "6f12",
	"./icon-vacation.svg": "66e4",
	"./icon-visit-doorbell.svg": "cbd6",
	"./icon-weights.svg": "936b",
	"./icon-wellness.svg": "47df",
	"./icon-work-briefcase-1.svg": "c510",
	"./icon-work.svg": "1c65"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "71ba";